// import

import {DocumentDuplicateIcon} from '@heroicons/react/outline';

import type {SeriesNode} from 'libs/model';

import {Header} from './Header';

// types

type Props = {
  series: SeriesNode;
};

// component

export function BlogSeriesHeader(props: Props) {
  const {series} = props;

  return (
    <Header
      color="green"
      icon={<DocumentDuplicateIcon />}
      title={series.meta.title}
      type="Series"
    >
      {series.body.trim() || series.meta.blurbMark}
    </Header>
  );
}

